module.exports = "/_next/static/images/3548bc3737cad606a138af3c949e0efe-value_proposal_md.png";